// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import LookupPayrollsRequestModel from '../../model/lookup-payrolls-request-model';
import LookupPayrollsRequestDTO from '../dto/lookup-payrolls-request-dto';
import dtoSchema from '../schemas/lookup-payrolls-request-schema';

export default abstract class LookupPayrollsRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<LookupPayrollsRequestDTO>) {
    super();
    if (data) {
      this.zipCode = data.zipCode;
      this.zipCodeAddition = data.zipCodeAddition;
    }
  }
  /**
  */
  zipCode?: string;
  /**
  */
  zipCodeAddition?: string;

  static toModel(dto: DeepPartial<LookupPayrollsRequestDTO>): LookupPayrollsRequestModel;
  static toModel(dto: DeepPartial<LookupPayrollsRequestDTO> | undefined | null): LookupPayrollsRequestModel | undefined;
  static toModel(dto: DeepPartial<LookupPayrollsRequestDTO> | undefined | null): LookupPayrollsRequestModel | undefined {
    return dto ? new LookupPayrollsRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<LookupPayrollsRequestModel> | LookupPayrollsRequestModel): LookupPayrollsRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      zipCode: unwrapped.zipCode,
      zipCodeAddition: unwrapped.zipCodeAddition,
    } as LookupPayrollsRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for LookupPayrollsRequestModel, can not map to LookupPayrollsRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
